<template>
  <div class="app-container">
    <div class="games-container">
      <div class="game-list-container">
        <div class="games-title">找回密碼</div>
        <div class="game-form">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="電郵地址" prop="email">
                  <el-row>
                    <el-col :span="15"><el-input v-model="ruleForm.email"></el-input></el-col>
                    <el-col :span="1">@</el-col>
                    <el-col :span="8">
                      <el-select v-model="value" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>                           
                </el-form-item>
                    <el-form-item label="電郵校驗" prop="code">
                      <el-row>
                        <el-col :span="8"><el-input v-model="ruleForm.code"></el-input></el-col>
                        <el-col :span="7"><span style="margin-right:10px"></span></el-col>
                        <el-col :span="1"><el-button type="warning" @click="getCode" style="margin-left:10px">獲取電郵校驗碼</el-button></el-col>
                      </el-row>  
                </el-form-item>
                <el-form-item prop="agree">
                    <el-checkbox checked>同意接受 <a href="/policy">《會員服務條款》</a> .<a href="/policy">《個人隱私條款》</a></el-checkbox>
                </el-form-item>
                <el-form-item style="text-align:center">
                    <el-button style="add_btn" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
  export default {
    data() {
        var validateemail = (rule, value, callback) => {
         const reg = /^[a-zA-Z0-9]{4,16}$/
        if (!reg.test(value)) {
            callback(new Error('電郵地址必須由字母或數字組合,請輸入4-16位字符'))
        } else {
            callback();
        }
      };
      var validatecode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('請輸入電郵校驗碼'));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          email:'',
          code:'',
        },
        rules: {
          email: [
            { validator: validateemail, trigger: 'blur' }
          ],
          code: [
            { validator: validatecode, trigger: 'blur' }
          ],
        },
        options: [{
          value: 'gmail.com',
          label: 'gmail.com'
        }, {
          value: 'outlook.com',
          label: 'outlook.com'
        }, {
          value: 'live.com',
          label: 'live.com'
        }, {
          value: 'yahoo.com',
          label: 'yahoo.com'
        }, {
          value: 'icloud.com',
          label: 'icloud.com'
        }, {
          value: 'qq.com',
          label: 'qq.com'
        }, {
          value: '126.com',
          label: '126.com'
        }],
        value: 'gmail.com',
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
                this.$axios
                    .get("/Recovery.asp", {
                    params: {
                      email:this.ruleForm.email+"@"+this.value,
                      code:this.ruleForm.code,
                    }
                    })
                    .then((res)=>{
                      console.log('data',res.data)
                      if(res.data.code != '200'){
                        this.$message({
                            message: res.data.data,
                            type: "error"
                        });
                      }else{
                        this.$router.push({path:'/success',query:{title:'找回成功',msg:'閣下的MOXGAME會員資料將發送到預留的電郵地址。'}});                
                      }

                    })
                    .catch((error)=>{
                    this.$message({
                        message: "請求超時，請稍後再嘗試",
                        type: "error"
                    });
                });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      getCode() {

        this.$refs.ruleForm.validateField('email',(error) => {
          if (!error) {
                this.$axios
                    .get("/getModCode.asp", {
                    params: {
                        email: this.ruleForm.email+"@"+this.value
                    }
                    })
                    .then((res)=>{
                      if(res.data.code != '200'){
                        this.$message({
                            message: res.data.data,
                            type: "error"
                        });
                      }else{
                        this.$message({
                            message: "發送成功，如未收到請檢查垃圾郵箱",
                            type: "success"
                        });                    
                      }

                    })
                    .catch((error)=>{
                    this.$message({
                        message: "請求超時，請稍後再嘗試",
                        type: "error"
                    });
                });
           }
        });
    },
    }
  }
</script>


 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a:link {color:#409EFF; text-decoration:none;} 
a:active{color:#409EFF; text-decoration:none;}
a:visited {color:#409EFF; text-decoration:none;}
a:hover {color:#409EFF; text-decoration:none;}
.app-container {
  display: block;
}
.games-container {
  max-width: 1281px;
  margin: auto;
}
.game-list-container {
  padding-bottom: 50px;
}
.games-title {
  margin-top: 20px;
  margin-left: 12px;
  font-size: 24px;
  font-family: Noto Sans KR, sans-serif;
  font-weight: 400;
  color: #000;
  opacity: 0.87;
  padding-bottom: 20px;
}
.game-form {
    max-width: 500px;
    margin:0 auto;
}
.el-button--primary {
    min-width:228px;
    min-height: 38px;
}

</style>


// WEBPACK FOOTER //
// src/components/Recovery.vue